export const listPurchaseOrdersQuery = `
  query ListPurchaseOrders($input: ListPurchaseOrdersInput) {
    listPurchaseOrders(input: $input) {
      code
      orders {
        id
        orderNumber
        supplierId
        procurementStatus
        createdAt
        lines { stockItemId stockItemName quantity unit }
      }
    }
  }
`;

export const createPurchaseOrderQuery = `
  mutation CreatePurchaseOrder($input: CreatePurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      code
      order { id orderNumber procurementStatus }
    }
  }
`;

export const approvePurchaseOrderQuery = `
  mutation ApprovePurchaseOrder($input: ProcurementOrderIdInput!) {
    approvePurchaseOrder(input: $input) {
      code
      order { id procurementStatus }
    }
  }
`;

export const createGrnQuery = `
  mutation CreateGrn($input: CreateGrnInput!) {
    createGrn(input: $input) {
      code
      order { id orderNumber procurementStatus }
    }
  }
`;

export const postGrnQuery = `
  mutation PostGrn($input: ProcurementOrderIdInput!) {
    postGrn(input: $input) {
      code
      order { id procurementStatus }
    }
  }
`;

export const listExpenseRequestsQuery = `
  query ListExpenseRequests($input: ListExpenseRequestsInput) {
    listExpenseRequests(input: $input) {
      code
      expenses { id title category amount currency status createdAt }
      totalElements
    }
  }
`;

export const createExpenseRequestQuery = `
  mutation CreateExpenseRequest($input: CreateExpenseRequestInput!) {
    createExpenseRequest(input: $input) {
      code
      expense { id title amount status }
    }
  }
`;

export const submitExpenseRequestQuery = `
  mutation SubmitExpenseRequest($input: ExpenseIdInput!) {
    submitExpenseRequest(input: $input) {
      code
      expense { id status }
    }
  }
`;

export const educationDashboardSummaryQuery = `
  query EducationDashboardSummary {
    educationDashboardSummary {
      code
      pendingExpenseTotal
      approvedExpenseTotal
      expenseCount
      overdueInvoiceCount
      feeCollectedTotal
      feeOutstandingTotal
      lowStockCount
    }
  }
`;

export const auditTimelineQuery = `
  query AuditTimeline($input: AuditTimelineInput!) {
    auditTimeline(input: $input) {
      code
      events { id action summary actorId createdAt }
    }
  }
`;

export const listPendingApprovalsQuery = `
  query ListPendingApprovals($input: ListPendingApprovalsInput) {
    listPendingApprovals(input: $input) {
      code
      approvals { id subjectType subjectId status createdAt }
    }
  }
`;

export const approveApprovalRequestQuery = `
  mutation ApproveApprovalRequest($input: ApprovalIdInput!) {
    approveApprovalRequest(input: $input) {
      code
      approval { id status }
    }
  }
`;
